/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedPointHistoryListDto } from '../models/PaginatedPointHistoryListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PointHistoriesService {
  /**
   * 내 포인트 내역 조회
   * 내 포인트 내역을 조회합니다.
   * @returns PaginatedPointHistoryListDto
   * @throws ApiError
   */
  public static pointHistoryControllerFindPointHistoriesByUser({
    page = 1,
    itemsPerPage = 30,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedPointHistoryListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/me/point-histories',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }
}
